const LIST_ITEM_HOOK = '[js-hook-icon-list-item]';

const ACTIVE_CLASS = 'is--active';
const HIDDEN_CLASS = 'u-hidden';
const carouselTiming = 5000;

class IconListCarousel {
  constructor(element) {
    this.element = element;
    this.listItems = [...this.element.querySelectorAll(LIST_ITEM_HOOK)];

    this.autoRotateListItems();
  }

  autoRotateListItems() {
    let currentItemIndex = 0;
    const totalItems = this.listItems.length;

    this.setListItemActiveClass(currentItemIndex);

    setInterval(() => {
      if ((totalItems - 1) > currentItemIndex) {
        currentItemIndex++;
      } else {
        currentItemIndex = 0;
      }

      this.setListItemActiveClass(currentItemIndex);

    }, carouselTiming);
  }

  setListItemActiveClass(index) {
    this.listItems.forEach(item => {
      item.classList.remove(ACTIVE_CLASS);
      item.classList.add(HIDDEN_CLASS);
    })

    this.listItems[index].classList.add(ACTIVE_CLASS);
    this.listItems[index].classList.remove(HIDDEN_CLASS);
  }
}

export default IconListCarousel;
